// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2Rh78","label":"CategoryService_label__YjeBQ","location":"CategoryService_location__2CtT7"};